(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.initProductCardSplides = function (container = document) {
    if (typeof Splide === 'undefined') {
      setTimeout(() => window.initProductCardSplides(container), 50);
      return;
    }
    const productSplides = container.querySelectorAll('.splide--product-card');
    productSplides.forEach(function (el) {
      if (el.classList.contains('is-initialized')) return;
      new Splide(el, {
        type: 'slide',
        drag: false,
        arrows: true,
        pagination: false,
        rewind: true,
        gap: 0,
        padding: 0,
      }).mount();
      el.classList.add('is-initialized');
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    // === Money formatting ===
    const productCardPrices = document.querySelectorAll('[data-product-card-price]');
    productCardPrices.forEach(function (el) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        el.textContent = Shopify.formatMoney(el.dataset.productCardPrice).replace(/\s+/g, '');
      }
    });

    // === Splide sliders ===
    window.initProductCardSplides();

    // === Quick-add button: spinner + event dispatch ===
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.quick-add-btn[data-product-handle]');
      if (!btn || btn.disabled) return;

      const handle = btn.dataset.productHandle;
      if (!handle) return;

      // Note: Show spinner ring around the + icon
      if (!btn.querySelector('.qa-spinner')) {
        const spinner = document.createElement('span');
        spinner.className = 'qa-spinner';
        btn.appendChild(spinner);
      }
      const icon = btn.querySelector('.qa-icon');
      if (icon) icon.style.opacity = '0';
      btn.disabled = true;

      window.dispatchEvent(new CustomEvent('quick-add:open', { detail: { handle: handle } }));
    });

    // Note: Remove spinner when overlay signals ready
    window.addEventListener('quick-add:ready', function () {
      document.querySelectorAll('.quick-add-btn').forEach(function (btn) {
        const spinner = btn.querySelector('.qa-spinner');
        if (spinner) spinner.remove();
        const icon = btn.querySelector('.qa-icon');
        if (icon) icon.style.opacity = '';
        btn.disabled = false;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
